/**
 * Created by why on 2019/10/21.
 */
/**
 * Created by why on 2019/10/21.
 */
import axios from '@/libs/api.request'
export const getMessageDetailByCondition = (data) => {
  return axios.request({
    url: '/messageDetail/getByCondition',
    params: data,
    method: 'get'
  })
}

export const getByStatusPage = (data) => {
  return axios.request({
    url: '/messageDetail/getByStatusPage',
    params: data,
    method: 'get'
  })
}

export const messageDetailSave = (data) => {
  return axios.request({
    url: '/messageDetail/save',
    data: data,
    method: 'post'
  })
}

export const messageDetailEdit = (data) => {
  return axios.request({
    url: '/messageDetail/edit',
    data: data,
    method: 'post'
  })
}

export const messageDetailDelByIds = (ids) => {
  return axios.request({
    url: `/messageDetail/delByIds/${ids}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/message-detail-manage.js